<template>
  <v-layout>
    <div class="col">
      <div class="head-page-title hide-for-small-only">
        <h1 class="main-title">Bedrijfsgegevens</h1>
      </div>
      <ul class="tabs">
        <tab-button
          :name="'details'"
          :title="'Bedrijf en contactpersoon'"
          :active="activeTab==='details'"
          :aria-controls="'details'"
          :href="'#details-panel'"
          @click="activateDetailsTab"
        />
        <tab-button
          :name="'addresses'"
          :title="'Adressen'"
          :active="activeTab==='addresses'"
          :aria-controls="'addresses'"
          :href="'#addresses-panel'"
          @click="activateAddressesTab"
        />
      </ul>
      <div class="tabs-content">
        <section id="details-panel"
                 :class="{'content': true, 'active': activeTab==='details', 'aria-hidden': activeTab==='details'}"
                 aria-hidden="false"
        >
          <company-contact-details-form :company="company" @cancel="cancel()"/>
        </section>
        <section id="addresses-panel"
                 :class="{'content': true, 'active': activeTab==='addresses', 'aria-hidden': activeTab==='addresses'}"
                 aria-hidden="false"
                 class="content"
        >
          <company-addresses-form :company="company" @cancel="cancel()"/>
        </section>
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'
import CompanyContactDetailsForm from '../components/forms/CompanyContactDetailsForm'
import CompanyAddressesForm from '../components/forms/CompanyAddressesForm'
import { mapState } from 'vuex'
import TabButton from '../components/tabs/TabButton'

export default {
  name: 'ComanyPage',
  components: {
    VLayout,
    CompanyContactDetailsForm,
    CompanyAddressesForm,
    TabButton
  },
  data: () => ({
    activeTab: 'details'
  }),
  computed: {
    ...mapState('company', {
      company: state => state.company
    })
  },
  methods: {
    cancel () {
      this.$router.push({name: 'welcome'})
    },
    activateDetailsTab () {
      this.activeTab = 'details'
    },
    activateAddressesTab () {
      this.activeTab = 'addresses'
    }
  }
}
</script>

<style scoped>
  ul.tabs li.tab-title a:focus {
    box-shadow: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/CompanyPage.vue